import React, { useState, useEffect, useCallback, useRef } from "react";
import { motion } from "framer-motion";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { ReactComponent as SvgDecoratorBlob1 } from "images/svg/svg-decorator-blob-5.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "images/svg/svg-decorator-blob-7.svg";
import Noimg from "../images/no_img.jpg";
import { getProduct, orderStatus } from "api/ProductApi";
import { currentRegister, filterFormatToDate } from "utility/Constant.js";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  deleteCustomerLike,
  createCustomerLike,
  createCustomerWish,
  deleteCustomerWish,
  productLikeCount,
} from "api/Like&WishCountApi";
import { getBranchId, getCustomerId } from "utility/HeaderConfig";
import { getPageProductType } from "api/ProductTypeApi";
import { getAllProductSubCate } from "api/ProductSubCateApi";
import { getAllProductCate } from "api/ProductCategoryApi";
import { genderBasedIcons } from "components/GenderBasedIcons";
// import no_data from "images/no_data.png";
import logo from "../images/Logo.png";
import SkeletonLoader from "components/SkeletonLoader";
import { dayClose } from "../api/NewSchemeApi";
import moment from "moment";
import SEO from "components/headers/Seo";
import { useCartContext } from "context/UseCartContext";


const Container = tw.div`relative overflow-hidden`;
const TabContent = tw(motion.div)`block `;
const CardContainer = tw.div`mt-4 w-full relative`;
const Card = tw(
  motion.div
)`bg-white block mx-auto  sm:mx-0 no-underline hover:shadow-2xl rounded-lg duration-500 cursor-pointer `;
const CardImageContainer = styled.div`
  ${(props) =>
    css`
      background-image: url("${props.imageSrc}");
    `}
  ${tw`bg-center bg-cover relative h-80 border border-gray-400 border-solid rounded-t-lg `}
`;
const CardText = tw.div`p-4 pb-1 text-gray-900 bg-gray-200 border border-gray-400 border-solid rounded-b-lg`;
const CardTitle = tw.h5`text-sm group-hover:text-yellow-600 no-underline  text-gray-600 lowercase`;
const CardContent = tw.p`mt-1 mb-2 text-sm font-medium text-custom-100  uppercase`;
const DecoratorBlob1 = styled(SvgDecoratorBlob1)`
  ${tw`pointer-events-none -z-20 absolute right-0 top-0 h-64 w-64 opacity-15 transform translate-x-2/3 -translate-y-12 text-pink-400`}
`;
const DecoratorBlob2 = styled(SvgDecoratorBlob2)`
  ${tw`pointer-events-none -z-20 absolute left-0 bottom-0 h-80 w-80 opacity-15 transform -translate-x-2/3 text-custom-100`}
`;
const CardRating = styled.div`
  ${tw` text-sm font-normal flex items-center justify-center  text-base text-gray-600 cursor-pointer rounded-full p-2 border-2 border-gray-400 border-dotted  bg-white`}
`;


export default ({ configImages }) => {
  /*
   * To customize the tabs, pass in data using the `tabs` prop. It should be an object which contains the name of the tab
   * as the key and value of the key will be its content (as an array of objects).
   * To see what attributes are configurable of each object inside this array see the example above for "Starters".
   */
  const location = useLocation();
  const myparam = location.state;
  const paramsId = location.search;
  const urlParams = new URLSearchParams(paramsId);
  const subCat = urlParams.get("subCatagoryId");
  const history = useNavigate();
  const [filterApplied, setFilterApplied] = useState(false);
  let URL = window.location.href;
  const [dataFetched, setDataFetched] = useState(false);
  const scrollPosition = useRef(null);

  const [banner, setBanner] = useState([]);
  const [loading, setLoading] = useState(false);
  const [listLoading, setListLoading] = useState(true);
  const [size, setSize] = useState(21);
  const [totalCount, setTotalCount] = useState(0);

  const [productType, setProductType] = useState([]);
  const [productSubCate, setProductSubCate] = useState([]);
  const [productCategory, setCategoryList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [dayClosedDates, setDayClosedDates] = useState("");
  const [orderStatusSale, setOrderStatusSale] = useState([]);
  const [orderStatusTransfer, setOrderStatusTransfer] = useState([]);
  const [orderStatusSold, setOrderStatusSold] = useState([]);
  const [likeState, setLikeState] = useState({});
  const [wishState, setWishState] = useState({});
  const [productFilter, setProductFilter] = useState({});
  const params = new URLSearchParams(location.search);
  const categoryId = params.get("category");
  const categoryData = location.state?.category;
  const [sortedList, setSortedList] = useState([]);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [selectedList, setSelectedList] = useState({
    type: "",
    category: "",
    subCategory: "",
    gender: "",
    // price: "",
    minWt: '',
    maxWt: '',
    sortBy: 'desc',
    status: 'available'
  });
  //eslint-disable-next-line
  const [lists, setLists] = useState([
    "gold", "silver", "diamond", "platinum"
  ])
  const { dispatch } = useCartContext();
  const [totalElements, setTotalElements] = useState(0);
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  useEffect(() => {
    // if (myparam) {
    //   getProductType()
    //   setSelectedList({
    //     ...selectedList,
    //     type: myparam && myparam.type ? myparam.type.id : "",
    //     category:
    //       myparam && myparam.category
    //         ? myparam.category.id
    //         : selectedList.category,
    //     subCategory: "",
    //     typeName: myparam && myparam.type ? myparam.type.name : "",
    //     categoryName:
    //       myparam && myparam.category
    //         ? myparam.category.categoryName
    //         : selectedList.categoryName,
    //     subCategoryName: "",
    //     genderName: "",
    //     // priceName: "",
    //     minWtName: "",
    //     maxWtName: "",
    //   });
    // }
    if (myparam) {
      getProductType()
      setSelectedList({
        ...selectedList,
        subCategory: myparam?.cat?.id,
        category: myparam?.cat?.metaProdCateId ? myparam?.cat?.metaProdCateId : myparam?.category?.id,
        type: myparam?.cat?.metaProdTypeId ? myparam?.cat?.metaProdTypeId : myparam?.category?.metaProdTypeId
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myparam]);


  useEffect(() => {
    if (!loading && productList !== null) {
      setDataFetched(true);
    }
  }, [loading, productList]);

  useEffect(() => {
    Promise.all([
      getOrderStatus(),
    ]).then((result) => {
      if (myparam?.category) {
        getProducts(orderStatusSale, orderStatusTransfer, orderStatusSold)
        setSelectedList({
          ...selectedList,
          type: myparam && myparam.category.metaProdType ? myparam.category.metaProdTypeId : "",
          category: myparam && myparam.category.categoryName ? myparam.category.id : selectedList.category,
          subCategory: "",
          typeName: myparam && myparam.category.metaProdType ? myparam.category.metaProdType : "",
          categoryName: myparam && myparam.category.categoryName ? myparam.categoryName : selectedList.category,
          subCategoryName: "",
          genderName: "",
          // priceName: "",
          minWtName: "",
          maxWtName: "",
        });
      }
      if (myparam?.type) {
        setSelectedList({
          ...selectedList,
          type: myparam.type.id,
          category: "",
          subCategory: "",
          typeName: myparam.type.name,
          categoryName: "",
          subCategoryName: "",
          // price: "",
          // priceName: "",
          minWt: "",
          minWtName: "",
          maxWt: "",
          maxWtName: "",
        });
      }
      // setOrderStatusSale(orderStatusSale)
      // setOrderStatusTransfer(orderStatusTransfer)
      // setOrderStatusSold(orderStatusSold)


      const { search } = location;

      const params = new URLSearchParams(search);
      const productFilters = Object.fromEntries(
        [...params.entries()].map(([key, value]) => [
          key,
          isNaN(value) ? value : Number(value),
        ])
      );
      if (productFilters?.statusId?.split(",")[0] ?? false) {
        setOrderStatusSale(productFilters?.statusId?.split(",")[0]);
      }
      if (productFilters?.statusId?.split(",")[1] ?? false) {
        setOrderStatusTransfer(productFilters?.statusId?.split(",")[1]);
      }
      if (productFilters?.statusId?.split(",")[2] ?? false) {
        setOrderStatusSold(productFilters?.statusId?.split(",")[2]);
      }
      setSelectedList((prev) => ({
        ...prev,
        ...productFilters,
      }));
    })
    getCategoryList();
    getProductSub();
    getBanner();
    //eslint-disable-next-line
  }, []);

  // useEffect(() => {
  //   getOrderStatus();
  //   if (
  //     selectedList.type ||
  //     selectedList.category ||
  //     selectedList.subCategory ||
  //     selectedList.gender ||
  //     // selectedList.price ||
  //     selectedList.minWt ||
  //     selectedList.maxWt ||
  //     selectedList.status
  //   ) {
  //     // size
  //     dayClose({
  //       module: "Sales",
  //       branchId: getBranchId(),
  //     }).then((data) => {
  //       if (data.response.length > 0) {
  //         let dateString = data.response[0].activeDate;
  //         let date = moment(dateString, "MMM DD, YYYY, h:mm:ss A");
  //         let dayCloseDate = date.format("YYYY-MM-DD");
  //         getProductList(dayCloseDate);
  //       }
  //     });
  //   }
  //   //eslint-disable-next-line
  // }, [selectedList, size]);

  //  initial code 
  // const getProducts = (orderStatusSale, orderStatusTransfer, orderStatusSold) => {
  //   let filterData = {
  //     allowCatalogue: 1,
  //     beforeCreatedAt: currentRegister(),
  //     demoStatus: "Demo_Completed,Demo_Cancelled,Available_For_Demo",
  //     metaProdCateEnty: myparam?.category?.categoryName ? myparam.category.id : selectedList.category,
  //     metaProdTypeEnty: myparam?.category?.metaProdType ? myparam.category.metaProdTypeId : '',
  //     removeHp: "HP-",
  //     removeNTP: "NTP-",
  //     sortType: true,
  //     statusId: `${orderStatusSale}, ${orderStatusTransfer}, ${orderStatusSold}`,
  //     sort: "asc",
  //   }
  //   getProduct(size, filterData)
  //   .then((data) => {
  //     const newProducts = data.response.content.filter(
  //       (product) => {
  //       return !productList.find(
  //         (prevProduct) => prevProduct.id === product.id);
  //     });

  //     if (newProducts.length > 0) {
  //       setProductList((prevProducts) => [...prevProducts, ...newProducts]);
  //     }

  //     setLoading(false);
  //   })
  //   .catch((err) => {
  //     console.log(err);
  //   });
  // }

  // ........fetch method
  const getProducts = async (orderStatusSale, orderStatusTransfer, orderStatusSold) => {
    let filterData = {
      allowCatalogue: 1,
      beforeCreatedAt: currentRegister(),
      demoStatus: "Demo_Completed,Demo_Cancelled,Available_For_Demo",
      metaProdCateEnty: myparam?.category?.categoryName ? myparam.category.id : selectedList.category || "",
      metaProdTypeEnty: myparam?.category?.metaProdType ? myparam.category.metaProdTypeId : selectedList.type || "",
      removeHp: "HP-",
      removeNTP: "NTP-",
      sortType: true,
      statusId: `${orderStatusSale}, ${orderStatusTransfer}, ${orderStatusSold}`,
      sort: "asc",
    }
    if (orderStatusSale.length <= 0 || orderStatusTransfer.length <= 0 || orderStatusSold.length <= 0) {
      delete filterData.statusId
    }
    if (selectedList.minWt) {
      filterData.grossWeightFrom = Number(selectedList.minWt);
    }
    if (selectedList.maxWt) {
      filterData.grossWeightTo = Number(selectedList.maxWt);
    }
    try {
      setLoading(true);
      const { response } = await getProduct(size, filterData);
      const newProducts = response.content;
      const totalElements = response.totalCount;
      setTotalElements(totalElements);
      if (filterApplied) {
        setProductList(newProducts);
        setFilterApplied(false);
      } else {
        setProductList((prevList) => {
          const uniqueProducts = [...prevList, ...newProducts.filter((product) => !prevList.some((p) => p.id === product.id))];
          return uniqueProducts;
        });
      }
      if (newProducts.length < size) {
        setHasMoreData(false);
      } else {
        setHasMoreData(true);
      }
      await new Promise(resolve => setTimeout(resolve, 1000));
      setLoading(false);
      setIsFirstLoad(false);
    } catch (err) {
      console.error("Error fetching data:", err);
      setLoading(false);
    }
  }

  const getOrderStatus = async () => {
    try {
      const data = await orderStatus({ multiOrderStatus: "sale,Transferred,Sold" });

      if (!data || !data.response) {
        console.error("Invalid API response:", data);
        return;
      }
      const statusResponse = data.response;
      const saleData = [];
      const transferData = [];
      const soldData = [];

      statusResponse.forEach((item) => {
        const status = item.orderStatusName.toLowerCase();
        if (status === "sale") {
          saleData.push(item.id);
        } else if (status === "transferred") {
          transferData.push(item.id);
        } else if (status === "sold") {
          soldData.push(item.id);
        }
      });

      setOrderStatusSale(saleData);
      setOrderStatusTransfer(transferData);
      setOrderStatusSold(soldData);
    } catch (err) {
      console.error("API Error:", err);
    }
  };

  const getProductType = () => {
    let pList = [];
    setListLoading(true);
    getPageProductType({ active: 1 }).then((data) => {
      setListLoading(true);
      let response = data.response.content;
      pList = response.filter((data) => data.metaProductCategoryList.length > 0 && data.id)
      pList.reverse();
      setProductType(pList);
      setListLoading(false);
    });
  };

  const getCategoryList = () => {
    setListLoading(true);
    let visibilityList = [];
    let filterData = {
      metaProdTypeEnty: selectedList.type ? selectedList.type : "",
      // visibilityMode: "WEB_MOBILE,MOBILE",
    };
    if (filterData.metaProdTypeEnty === "") {
      delete filterData.metaProdTypeEnty;
    }
    getAllProductCate(filterData).then((data) => {
      const productResponse = data.response;
      visibilityList = productResponse.filter(item => item.visibilityMode === 'WEB_MOBILE' || item.visibilityMode === 'MOBILE')
      setCategoryList(visibilityList);
      setListLoading(false);
    });
  };

  const getProductSub = () => {
    setListLoading(true);
    let filterData = {
      metaProdTypeEnty: selectedList.type ? selectedList.type : "",
      metaProdCateEnty: selectedList.category ? selectedList.category : "",
    };
    if (filterData.metaProdTypeEnty === "") {
      delete filterData.metaProdTypeEnty;
    }
    if (filterData.metaProdCateEnty === "") {
      delete filterData.metaProdCateEnty;
    }
    getAllProductSubCate(filterData).then((data) => {
      let response = data.response;
      setProductSubCate(response);
      setListLoading(false);
    });
  };

  // const handleChange = (e) => {
  //   let target = e.target;
  //   let input = target.name;
  //   let value = target.value;
  //   let index = e.nativeEvent.target.selectedIndex;
  //   let text = e.nativeEvent.target[index]?.text;

  //   setSelectedList((prevState) => ({
  //     ...prevState,
  //     [input]: value,
  //     [`${input}Name`]: text, // Only add a name field if applicable
  //   }));
  // };

  const handleChange = (e) => {
    let target = e.target;
    let input = target.name;
    let value = target.value;
    let index = e.nativeEvent.target.selectedIndex;
    let text = e.nativeEvent.target[index]?.text;

    if (input === "type") {
      setSelectedList({
        ...selectedList,
        type: value,
        category: "",
        subCategory: "",
        typeName: text,
        categoryName: "",
        subCategoryName: "",
      });
    } else if (input === "category") {
      setSelectedList({
        ...selectedList,
        category: value,
        subCategory: "",
        categoryName: text,
        subCategoryName: "",
      });
    } else if (input === "subCategory") {
      setSelectedList({
        ...selectedList,
        subCategory: value,
        subCategoryName: text,
      });
    } else if (input === "gender") {
      setSelectedList({
        ...selectedList,
        gender: value,
        genderName: text,
      });
    } else if (input === "status") {
      setSelectedList({
        ...selectedList,
        status: value,
        statusName: text,
      });
    }
    // else if (input === "price") {
    //   setSelectedList({
    //     ...selectedList,
    //     price: value,
    //     priceName: text,
    //   })
    // } 
    else if (input === "minWt") {
      setSelectedList({
        ...selectedList,
        minWt: value,
        minWtName: text,
      })
    } else if (input === "maxWt") {
      setSelectedList({
        ...selectedList,
        maxWt: value,
        maxWtName: text,
      })
    }
    else if (input === "sortBy") {
      setSelectedList({
        ...selectedList,
        sortBy: value,
        sortByName: text,
      });
    }
  };


  //eslint-disable-next-line
  const dayCloseDay = () => {
    dayClose({
      module: "Sales",
      branchId: getBranchId(),
    }).then((data) => {
      if (data.response.length > 0) {
        let dateString = data.response[0].activeDate;
        let date = moment(dateString, "MMM DD, YYYY, h:mm:ss A");
        let dayCloseDate = date.format('YYYY-MM-DD');
        setDayClosedDates(dayCloseDate);
      }
    });
  };


  const getProductList = (dayCloseDate) => {
    setLoading(true);

    let filterData = {
      removeNTP: "NTP-",
      removeHP: "HP-",
      beforeCreatedAt: filterFormatToDate(dayCloseDate),
      branch: getBranchId(),
      metaProdTypeEnty: selectedList.type || "",
      metaProdCateEnty: selectedList.category || "",
      productSubcategory: selectedList.subCategory || "",
      // metaProdTypeEnty: selectedList.type || filters.metaProdTypeEnty,
      // metaProdCateEnty: selectedList.category || filters.metaProdCateEnty,
      // productSubcategory: selectedList.subCategory || filters.productSubcategory,
      userType: selectedList.gender || "",
      // totalAmtFrom: selectedList.price.split('-')[0] === 'below' ? '' : Number(selectedList.price.split('-')[0]),
      // totalAmtTo: selectedList.price.split('-')[1] === 'above' ? '' : Number(selectedList.price.split('-')[1]),
      grossWeightFrom: selectedList.minWt ? Number(selectedList.minWt) : null,
      grossWeightTo: selectedList.maxWt ? Number(selectedList.maxWt) : null,
      statusId:
        selectedList.status === "allStatus"
          ? `${orderStatusSale},${orderStatusTransfer},${orderStatusSold}`
          : `${orderStatusSale},${orderStatusTransfer}`,
      allowCatalogue: 1,
      productDemoStatus: "Available_For_Demo,Demo_Completed,Demo_Cancelled",
      ...selectedList
    };
    if (orderStatusSale.length <= 0 || orderStatusTransfer.length <= 0 || orderStatusSold.length <= 0) {
      delete filterData.statusId
    }
    setProductFilter(filterData);
    Object.keys(filterData).forEach((key) => {
      if (filterData[key] === "") delete filterData[key];
    });
    // setProductFilter(filterData);
    // if (selectedList.price === '') {
    //   delete filterData.totalAmtFrom
    //   delete filterData.totalAmtTo
    // }
    if (selectedList.minWt === '') {
      delete filterData.grossWeightFrom
    }
    if (selectedList.maxWt === '') {
      delete filterData.grossWeightTo
    }
    if (
      orderStatusSale.length > 0 &&
      orderStatusTransfer.length > 0 &&
      orderStatusSold.length > 0
    ) {
      getProduct(size, filterData, selectedList.sortBy)
        //     .then((data) => {
        //       let productData = typeof data.response === "string"
        //         ? JSON.parse(data.response).content
        //         : data.response.content;
        //       let sortedData = sortAfterApi(productData, selectedList.sortBy);
        //       setProductList(sortedData);
        //       setLoading(false);
        //     })
        // } else {
        //   setLoading(false);
        .then((data) => {
          let productData = typeof data.response === "string"
            ? JSON.parse(data.response).content
            : data.response.content;
          let totalCount = data.response.totalElements || data.response.totalCount;
          setTotalCount(totalCount);
          if (productList.length >= totalCount) {
            setHasMoreData(false);
          } else {
            setHasMoreData(true);
          }
          let sortedData = sortAfterApi(productData, selectedList.sortBy);
          setProductList(sortedData);
          setLoading(false);
        })
    }
  };

  const sortAfterApi = (products, sortValue) => {
    if (sortValue === 'weight-low-high') {
      return sortByGrossWeight([...products], 'asc');
    } else if (sortValue === 'weight-high-low') {
      return sortByGrossWeight([...products], 'desc');
    } else if (sortValue === 'asc') {
      return [...products].sort((a, b) => b.totalAmount - a.totalAmount);
    } else if (sortValue === 'desc') {
      return [...products].sort((a, b) => a.totalAmount - b.totalAmount);
    }
    return products;
  };

  const handleClearAll = () => {
    // Reset filter state
    setSelectedList({
      type: "",
      category: "",
      subCategory: "",
      gender: "",
      typeName: "",
      categoryName: "",
      subCategoryName: "",
      genderName: "",
      minWt: "",
      minWtName: "",
      maxWt: "",
      maxWtName: "",
      status: 'available', // or whatever default status you want
      sortBy: 'desc'       // reset sorting as well if needed
    });

    // Clear product list to avoid showing old filtered data
    setProductList([]);

    // Reset filter applied flag so getProducts will append properly
    setFilterApplied(false);

    // Trigger fetch of products with no filters (default)
    getProducts(orderStatusSale, orderStatusTransfer, orderStatusSold);
  };


  const resetAll = () => {
    setSelectedList({
      type: "",
      category: "",
      subCategory: "",
      gender: "",
      typeName: "",
      categoryName: "",
      subCategoryName: "",
      genderName: "",
      // price: "",
      // priceName: "",
      minWt: "",
      minWtName: "",
      maxWt: "",
      maxWtName: "",
    });
  };



  // const loadMoreData = useCallback(() => {
  //   if (loading || !hasMoreData) return;
  //   setLoading(true);
  //   setTimeout(() => {
  //     setSize((prevSize) => prevSize + 10);
  //     setLoading(false);
  //   }, 1000);
  //   // eslint-disable-next-line
  // }, [loading, hasMoreData]);

  const loadMoreData = useCallback(() => {
    if (loading || !hasMoreData) return;
    setLoading(true);
    setSize((prevSize) => prevSize + 10);
    // eslint-disable-next-line
  }, [loading, hasMoreData, size]);

  const handleScroll = useCallback(() => {
    // scrollPosition.current = window.scrollY;
    if (loading || !hasMoreData) return;
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const fullHeight = document.documentElement.scrollHeight;
    const scrolledPercent = (scrollTop + windowHeight) / fullHeight;
    if (scrolledPercent >= 0.8) {
      loadMoreData();
    }
  }, [loading, hasMoreData, loadMoreData]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);


  useEffect(() => {
    if (
      selectedList.type ||
      selectedList.category ||
      selectedList.subCategory ||
      selectedList.gender ||
      selectedList.minWt ||
      selectedList.maxWt ||
      selectedList.status
    ) {
      dayClose({
        module: "Sales",
        branchId: getBranchId()
      }).then((data) => {
        if (data.response.length > 0) {
          let dateString = data.response[0].activeDate;
          let date = moment(dateString, "MMM DD, YYYY, h:mm:ss A");
          let dayCloseDate = date.format("YYYY-MM-DD");
          getProductList(dayCloseDate);
        }
      });
    } else {
      // if(productList.length <= 0){
      getProducts(orderStatusSale, orderStatusTransfer, orderStatusSold);
      // }
    }
    //eslint-disable-next-line
  }, [size, selectedList]);

  const getBanner = () => {
    configImages && configImages.E_COMMERCE_BANNERS.forEach((data) => {
      if (data.key === "productList") {
        setBanner(data.value);
      }
    });
  };

  const wishCountFunc = (product) => {
    if (getCustomerId() && getCustomerId() !== "onlinepayment") {
      const productId = product.productId ? product.productId : product.id;
      setWishState((prevState) => ({
        ...prevState,
        [productId]: !prevState[productId],
      }));

      if (wishState[productId]) {
        const deletWish = `customerId=${getCustomerId()}&productId=${productId}`;
        deleteCustomerWish(deletWish);
      } else {
        const createWish = `customerId=${getCustomerId()}&productId=${productId}&remark=liked`;
        createCustomerWish(createWish);
      }
    } else {
      dispatch({ type: "MODAL", payload: "login" });
    }
  };


  const likeCountFunc = (product) => {
    if (getCustomerId() && getCustomerId() !== "onlinepayment") {
      const productId = product.productId ? product.productId : product.id;
      setLikeState((prevState) => ({
        ...prevState,
        [productId]: !prevState[productId],
      }));

      if (likeState[productId]) {
        const deletLike = `customerId=${getCustomerId()}&productId=${productId}`;
        deleteCustomerLike(deletLike);
      } else {
        const createLike = `customerId=${getCustomerId()}&productId=${productId}&remark=liked`;
        createCustomerLike(createLike);
      }
    } else {
      dispatch({ type: "MODAL", payload: "login" });
    }
  };

  const handleOpenDetails = (categoryItem) => {
    window.open(`/ProductDetails/${categoryItem.id}/${categoryId}`, "_blank")
  }

  const sortByGrossWeight = (products, order) => {
    return products.sort((a, b) => {
      const weightA = parseFloat(JSON.parse(a.weight).grossWeight);
      const weightB = parseFloat(JSON.parse(b.weight).grossWeight);
      if (order === 'asc') {
        return weightA - weightB;
      } else {
        return weightB - weightA;
      }
    });
  };

  return (
    <Container>
      <SEO
        title='ProductList - Sri Mayuri Jewellers'
        description='Beginner friendly page for learning React Helmet.'
        name='Company name.'
        type='article' />
      {/* {banner && banner.length > 0 ? (
        <img src={banner} alt="Jewellery Product List " className="w-100" />
      ) : (
        <Skeleton tw="w-full" style={{ height: "200px" }} />
      )} */}
      {/* <div className="ptSans px-sm-5 px-0" tw="text-sm pt-3">
        <Link to="/" tw="mx-3 no-underline text-black">
          Home
        </Link>
        /
        <span tw="ml-3 text-custom-100 capitalize tracking-wide">
          {selectedList.typeName && selectedList.typeName
            ? selectedList.typeName
            : selectedList.categoryName && selectedList.categoryName}{" "}
        </span>
      </div> */}


      <div className="container pt-3 pb-5">
        <div className="row">
          {/* Left Sidebar - Filters */}
          <aside className="col-lg-3 col-md-4 mb-4 mt-2">
  {/* Mobile Filter Toggle Button - Only visible on small screens */}
  <div className="d-lg-none d-md-none mb-3">
    <button
      className="btn w-100 fw-bold text-uppercase d-flex align-items-center justify-content-center"
      onClick={() => document.getElementById('filters-sidebar').classList.toggle('d-none')}
      type="button"
      style={{
        backgroundColor: "#f0b917",
        color: "#222",
        border: "none",
        padding: "12px 0",
        fontSize: "1rem",
        letterSpacing: "1.5px",
        boxShadow: "0 6px 12px rgba(240,185,23,0.5)",
        transition: "background-color 0.3s ease, box-shadow 0.3s ease",
        borderRadius: "8px",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = "#d19f05";
        e.currentTarget.style.boxShadow = "0 8px 16px rgba(209,159,5,0.7)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "#f0b917";
        e.currentTarget.style.boxShadow = "0 6px 12px rgba(240,185,23,0.5)";
      }}
    >
      <i className="bi bi-funnel-fill me-2"></i>
      Show Filters
    </button>
  </div>

  {/* Filters Sidebar - Hidden by default on mobile, visible on desktop */}
  <div
    id="filters-sidebar"
    className="filters-sidebar p-4 bg-white rounded shadow-sm border custom-scrollbar d-lg-block d-md-block d-none"
    style={{
      height: "600px",
      overflowY: "auto",
      position: "sticky",
      top: 0,
    }}
  >
    {/* Close Button for Mobile - Only visible on small screens */}
    <div className="d-lg-none d-md-none d-flex justify-content-end mb-3">
      <button
        className="btn btn-sm btn-outline-secondary"
        onClick={() => document.getElementById('filters-sidebar').classList.add('d-none')}
        type="button"
        style={{
          borderColor: "#f0b917",
          color: "#f0b917"
        }}
      >
        <i className="bi bi-x-lg"></i> Close
      </button>
    </div>

    <h4
      className="mb-4 fw-bold text-uppercase"
      style={{ letterSpacing: "2px", color: "#333", borderBottom: "2px solid #f0b917", paddingBottom: "8px" }}
    >
      Filter By
    </h4>

    {/* --- Filter Group Template --- */}
    {/* For each filter, you can reuse this style */}
    <div className="mb-4">
      <label
        htmlFor="metalType"
        className="form-label fw-semibold text-dark"
        style={{ fontSize: "0.9rem", letterSpacing: "0.5px" }}
      >
        Metal Type
      </label>
      <select
        className="form-select shadow-sm"
        id="metalType"
        name="type"
        value={selectedList.type}
        onChange={handleChange}
        onFocus={getProductType}
        aria-label="Select Metal Type"
        style={{
          borderColor: "#f0b917",
          transition: "border-color 0.3s ease",
        }}
        onBlur={(e) => (e.target.style.borderColor = "#f0b917")}
      >
        <option value="" disabled hidden>
          Select Metal Type
        </option>
        {productType.length === 0 ? (
          <option disabled>No Data</option>
        ) : (
          productType.map((data) => (
            <option key={data.id} value={data.id}>
              {data.name}
            </option>
          ))
        )}
      </select>
    </div>

    {/* Repeat this block for other filters, updating label and select accordingly */}

    {/* Category */}
    <div className="mb-4">
      <label
        htmlFor="category"
        className="form-label fw-semibold text-dark"
        style={{ fontSize: "0.9rem", letterSpacing: "0.5px" }}
      >
        Category
      </label>
      <select
        className="form-select shadow-sm"
        id="category"
        name="category"
        value={selectedList.category}
        onChange={handleChange}
        onFocus={getCategoryList}
        aria-label="Select Category"
        style={{
          borderColor: "#f0b917",
          transition: "border-color 0.3s ease",
        }}
        onBlur={(e) => (e.target.style.borderColor = "#f0b917")}
      >
        <option value="" disabled hidden>
          Select Category
        </option>
        {productCategory.length === 0 ? (
          <option disabled>No Data</option>
        ) : (
          productCategory.map((data) => (
            <option key={data.id} value={data.id}>
              {data.categoryName}
            </option>
          ))
        )}
      </select>
    </div>

    {/* SubCategory */}
    <div className="mb-4">
      <label
        htmlFor="subCategory"
        className="form-label fw-semibold text-dark"
        style={{ fontSize: "0.9rem", letterSpacing: "0.5px" }}
      >
        Subcategory
      </label>
      <select
        className="form-select shadow-sm"
        id="subCategory"
        name="subCategory"
        value={selectedList.subCategory}
        onChange={handleChange}
        onFocus={getProductSub}
        aria-label="Select Subcategory"
        style={{
          borderColor: "#f0b917",
          transition: "border-color 0.3s ease",
        }}
        onBlur={(e) => (e.target.style.borderColor = "#f0b917")}
      >
        <option value="" disabled hidden>
          Select Subcategory
        </option>
        {productSubCate.length === 0 ? (
          <option disabled>No Data</option>
        ) : (
          productSubCate.map((data) => (
            <option key={data.id} value={data.id}>
              {data.subCategoryName}
            </option>
          ))
        )}
      </select>
    </div>

    {/* Gender */}
    {/* <div className="mb-4">
      <label
        htmlFor="gender"
        className="form-label fw-semibold text-dark"
        style={{ fontSize: "0.9rem", letterSpacing: "0.5px" }}
      >
        Gender
      </label>
      <select
        className="form-select shadow-sm"
        id="gender"
        name="gender"
        value={selectedList.gender}
        onChange={handleChange}
        aria-label="Select Gender"
        style={{
          borderColor: "#f0b917",
          transition: "border-color 0.3s ease",
        }}
        onFocus={(e) => (e.target.style.borderColor = "#d19f05")}
        onBlur={(e) => (e.target.style.borderColor = "#f0b917")}
      >
        <option value="" disabled hidden>
          Select Gender
        </option>
        {genderBasedIcons.map((data, index) => (
          <option key={index} value={data.gender}>
            {data.title}
          </option>
        ))}
      </select>
    </div> */}

    {/* Price Range */}
    {/* <div className="mb-4">
      <label
        htmlFor="price"
        className="form-label fw-semibold text-dark"
        style={{ fontSize: "0.9rem", letterSpacing: "0.5px" }}
      >
        Price Range
      </label>
      <select
        className="form-select shadow-sm"
        id="price"
        name="price"
        value={selectedList.price}
        onChange={handleChange}
        aria-label="Select Price Range"
        style={{
          borderColor: "#f0b917",
          transition: "border-color 0.3s ease",
        }}
        onFocus={(e) => (e.target.style.borderColor = "#d19f05")}
        onBlur={(e) => (e.target.style.borderColor = "#f0b917")}
      >
        <option value="" disabled hidden>
          Select Price Range
        </option>
        <option value="below-1000">Below 1K</option>
        <option value="5000-10000">5K - 10K</option>
        <option value="10000-15000">10K - 15K</option>
        <option value="15000-25000">15K - 25K</option>
        <option value="25000-above">25K & Above</option>
      </select>
    </div> */}

    {/* Min Weight */}
    <div className="mb-4">
      <label
        htmlFor="grossMinWt"
        className="form-label fw-semibold text-dark"
        style={{ fontSize: "0.9rem", letterSpacing: "0.5px" }}
      >
        Min Weight (gm)
      </label>
      <input
        type="number"
        className="form-control shadow-sm"
        id="grossMinWt"
        name="minWt"
        value={selectedList.minWt}
        onChange={handleChange}
        placeholder="Min Weight"
        aria-label="Minimum Weight"
        style={{ borderColor: "#f0b917" }}
        onFocus={(e) => (e.target.style.borderColor = "#d19f05")}
        onBlur={(e) => (e.target.style.borderColor = "#f0b917")}
      />
    </div>

    {/* Max Weight */}
    <div className="mb-4">
      <label
        htmlFor="grossMaxWt"
        className="form-label fw-semibold text-dark"
        style={{ fontSize: "0.9rem", letterSpacing: "0.5px" }}
      >
        Max Weight (gm)
      </label>
      <input
        type="number"
        className="form-control shadow-sm"
        id="grossMaxWt"
        name="maxWt"
        value={selectedList.maxWt}
        onChange={handleChange}
        placeholder="Max Weight"
        aria-label="Maximum Weight"
        style={{ borderColor: "#f0b917" }}
        onFocus={(e) => (e.target.style.borderColor = "#d19f05")}
        onBlur={(e) => (e.target.style.borderColor = "#f0b917")}
      />
    </div>

    {/* Clear All Filters Button */}
    <button
      className="btn w-100 fw-bold text-uppercase"
      onClick={handleClearAll}
      type="button"
      style={{
        backgroundColor: "#f0b917",
        color: "#222",
        border: "none",
        padding: "12px 0",
        fontSize: "1rem",
        letterSpacing: "1.5px",
        boxShadow: "0 6px 12px rgba(240,185,23,0.5)",
        transition: "background-color 0.3s ease, box-shadow 0.3s ease",
        borderRadius: "8px",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = "#d19f05";
        e.currentTarget.style.boxShadow = "0 8px 16px rgba(209,159,5,0.7)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = "#f0b917";
        e.currentTarget.style.boxShadow = "0 6px 12px rgba(240,185,23,0.5)";
      }}
    >
      Clear All Filters
    </button>
  </div>
</aside>

          <section
            className="col-lg-9 col-md-8 custom-scrollbar"
            style={{
              height: "calc(100vh - 120px)",
              overflowX: "hidden",
              overflowY: "auto",
              paddingRight: "8px",
            }}
          >
            <div className="mb-2 col-md-5 col-lg-3 py-sm-0 py-2">
              <span className="mt-2 item amshopby-item justify-content-center"
                tw="tracking-wide uppercase">
                <span tw="text-black">
                  {/* Showing: {productList.length} <span>items</span> */}
                  Showing: {totalCount} <span>items</span>
                </span>
              </span>
            </div>
            {(selectedList.type ||
              selectedList.category ||
              selectedList.subCategory ||
              selectedList.gender ||
              // selectedList.price ||
              selectedList.minWt ||
              selectedList.maxWt ||
              selectedList.status) && (
                <div className="container ">
                  <div className="px-sm-4 px-2 py-2 py-sm-3 mt-3 mx-0 border rounded row align-items-center w-100">
                    <span className="ptSans col-md-3 col-lg-3 px-md-2 d-none d-lg-block text-success text-custom-100 font-semibold">
                      Showing Results for:
                    </span>
                    <div className="d-flex justify-content-between align-items-center col-md-12 p-0 col-lg-9 col-xl-10">
                      <ul className="d-flex align-items-center m-0 p-0 ptSans flex-wrap">
                        {selectedList.typeName && (
                          <li className="item amshopby-item mx-2 mb-1">
                            <div
                              className="amshopby-filter-value text-black"
                              tw="tracking-wide uppercase"
                            >
                              {selectedList.typeName}
                            </div>
                            <span
                              className="amshopby-remove "
                              tw="cursor-pointer"
                              onClick={() =>
                                setSelectedList({
                                  ...selectedList,
                                  type: "",
                                  typeName: "",
                                })
                              }
                            >
                              <i
                                className="bi bi-x-circle-fill ms-2 text-secondary"
                                tw="text-base"
                              ></i>
                            </span>
                          </li>
                        )}
                        {selectedList.categoryName && (
                          <li className="item amshopby-item mx-2 mb-1">
                            <div
                              className="amshopby-filter-value text-black"
                              tw="tracking-wide uppercase"
                            >
                              {selectedList.categoryName}
                            </div>
                            <span
                              className="amshopby-remove "
                              tw="cursor-pointer"
                              onClick={() =>
                                setSelectedList({
                                  ...selectedList,
                                  category: "",
                                  categoryName: "",
                                })
                              }
                            >
                              <i
                                className="bi bi-x-circle-fill ms-2 text-secondary"
                                tw="text-base"
                              ></i>
                            </span>
                          </li>
                        )}
                        {selectedList.subCategoryName && (
                          <li className="item amshopby-item mx-2 mb-1">
                            <div
                              className="amshopby-filter-value text-black"
                              tw="tracking-wide uppercase"
                            >
                              {selectedList.subCategoryName}
                            </div>
                            <span
                              className="amshopby-remove "
                              tw="cursor-pointer"
                              onClick={() =>
                                setSelectedList({
                                  ...selectedList,
                                  subCategory: "",
                                  subCategoryName: "",
                                })
                              }
                            >
                              <i
                                className="bi bi-x-circle-fill ms-2 text-secondary"
                                tw="text-base"
                              ></i>
                            </span>
                          </li>
                        )}
                        {selectedList.genderName && (
                          <li className="item amshopby-item mx-2 mb-1">
                            <div
                              className="amshopby-filter-value text-black"
                              tw="tracking-wide uppercase"
                            >
                              {selectedList.genderName}
                            </div>
                            <span
                              className="amshopby-remove "
                              tw="cursor-pointer"
                              onClick={() =>
                                setSelectedList({
                                  ...selectedList,
                                  gender: "",
                                  genderName: "",
                                })
                              }
                            >
                              <i
                                className="bi bi-x-circle-fill ms-2 text-secondary"
                                tw="text-base"
                              ></i>
                            </span>
                          </li>
                        )}
                        {/* {selectedList.priceName && (
                    <li className="item amshopby-item mx-2 mb-1">
                      <div
                        className="amshopby-filter-value text-black"
                        tw="tracking-wide uppercase"
                      >
                        {selectedList.priceName}
                      </div>
                      <span
                        className="amshopby-remove "
                        tw="cursor-pointer"
                        onClick={() =>
                          setSelectedList({
                            ...selectedList,
                            price: "",
                            priceName: "",
                          })
                        }
                      >
                        <i
                          className="bi bi-x-circle-fill ms-2 text-secondary"
                          tw="text-base"
                        ></i>
                      </span>
                    </li>
                  )} */}
                        {selectedList.minWt && selectedList.maxWt && (
                          <li className="item amshopby-item mx-2 mb-1">
                            <div className="amshopby-filter-value text-black" tw="tracking-wide uppercase">
                              {selectedList.minWt}-{selectedList.maxWt}
                            </div>
                            <span
                              className="amshopby-remove"
                              tw="cursor-pointer"
                              onClick={() =>
                                setSelectedList({
                                  ...selectedList,
                                  minWt: "",
                                  maxWt: "",
                                })
                              }
                            >
                              <i className="bi bi-x-circle-fill ms-2 text-secondary" tw="text-base"></i>
                            </span>
                          </li>
                        )}

                        {selectedList.status && (
                          <li className="item amshopby-item mx-2 mb-1">
                            <div
                              className="amshopby-filter-value text-black"
                              tw="tracking-wide uppercase"
                            >
                              {selectedList.status}
                            </div>
                            <span
                              className="amshopby-remove "
                              tw="cursor-pointer"
                              onClick={() =>
                                setSelectedList({
                                  ...selectedList,
                                  status: "",
                                  status: "",
                                })
                              }
                            >
                              <i
                                className="bi bi-x-circle-fill ms-2 text-secondary"
                                tw="text-base"
                              ></i>
                            </span>
                          </li>
                        )}
                      </ul>
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex justify-content-start col-8">
                          <div className="input-group rounded-pill shadow-sm" style={{ width: "250px" }}>
                            {/* Optional icon on the left */}
                            <span
                              className="input-group-text bg-white border-0 rounded-start-pill"
                              style={{ width: "40px", justifyContent: "center" }}
                            >
                              <i className="bi bi-sort-up" style={{ color: "#f0b917", fontSize: "1.2rem" }}></i>
                            </span>

                            <select
                              className="form-select rounded-end-pill border-0"
                              style={{ paddingLeft: "1rem" }}
                              name="sortBy"
                              onChange={handleChange}
                              value={selectedList.sortBy}
                              aria-label="Sort by"
                            >
                              {/* <option value="desc">Price - Low to High</option> 
                                  <option value="asc">Price - High to Low</option> */}
                              <option value="weight-low-high">Weight - Low to High</option>
                              <option value="weight-high-low">Weight - High to Low</option>
                            </select>
                          </div>


                        </div>
                        <div className="d-flex gap-lg-3 col-5">
                          <span
                            className="mt-3"
                            tw="text-custom-100 sm:text-base text-sm font-semibold cursor-pointer"
                            style={{ marginRight: "-5px" }}
                            onClick={handleClearAll}
                          >
                            Clear all
                          </span>
                          {/* <span
                            className="mt-1"
                            style={{ color: "#25d366" }}
                            tw="text-custom-100 sm:text-base text-sm font-semibold cursor-pointer text-center"
                            onClick={() => {
                              const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
                                `${URL}?${new URLSearchParams(productFilter).toString()}`
                              )}`;
                              window.open(whatsappUrl, "_blank");
                            }}
                          >
                            <i
                              className="bi bi-whatsapp px-2 fs-2"
                              style={{ fontSize: "11px" }}
                              title="Send"
                            ></i>
                          </span> */}
                        </div>
                      </div>
                    </div>
                  </div >
                </div>
              )
            }
            {console.log(productList, 'productList')}
            {loading ? (
              <div className="text-center">
                <p>Please wait...</p>
              </div>
            ) : productList && productList.length > 0 ? (
              <div className="row">
                {productList
                  .sort((a, b) => {
                    const aHasImage = a.images && a.images !== '@#@' && a.images.split('@#@')[0].trim() !== "";
                    const bHasImage = b.images && b.images !== '@#@' && b.images.split('@#@')[0].trim() !== "";
                    const noImage1 = !aHasImage;
                    const noImage2 = !bHasImage;

                    if (noImage1 && !noImage2) return 1;
                    if (!noImage1 && noImage2) return -1;

                    if (aHasImage === bHasImage) return 0;
                    return aHasImage ? -1 : 1;
                  })
                  .map((categoryItem, index) => {
                    const weightJson = JSON.parse(categoryItem?.weight || "{}");
                    const netWeight = weightJson?.netWeight || "0";
                    return (
                      <TabContent
                        key={index}
                        transition={{ duration: 0.4 }}
                        className="col-md-6 col-lg-4 col-xl-3 mb-4 h6"
                      >
                        <CardContainer>
                          <Card
                            className="group position-relative shadow-sm rounded"
                            initial="rest"
                            whileHover="hover"
                            animate="rest"
                            onClick={() => handleOpenDetails(categoryItem)}
                            style={{
                              width: '100%',
                              aspectRatio: '1 / 1',
                              display: 'grid',
                              gridTemplateRows: '65% 35%',
                              backgroundColor: '#fff',
                              borderRadius: '8px',
                              overflow: 'hidden',
                              cursor: 'pointer',
                              boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                              position: 'relative',
                            }}
                          >
                            {/* Like/Wishlist icons top-right outside image */}
                            <div
                              style={{
                                position: 'absolute',
                                top: '5px',
                                right: '12px',
                                display: 'flex',
                                gap: '8px', // less gap for smaller icons
                                zIndex: 10,
                                backgroundColor: 'rgba(255, 255, 255, 0.85)', // subtle background to separate icons from image
                                borderRadius: '12px',
                                // padding: '4px 8px',
                                boxShadow: '0 0 6px rgba(0,0,0,0.1)',
                              }}
                            >
                              <CardRating
                                className={`${likeState[categoryItem.id] ? "hand" : ""} bi bi-hand-thumbs-up tooltip1`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  likeCountFunc(categoryItem);
                                }}
                                style={{ fontSize: '1rem', color: likeState[categoryItem.id] ? '#f0b917' : '#777', cursor: 'pointer' }}
                              >
                                {categoryItem.likesCount !== 0 && (
                                  <span className="tooltiptext">{categoryItem.likesCount}</span>
                                )}
                              </CardRating>
                              <CardRating
                                className={`${wishState[categoryItem.id] ? "like" : ""} bi bi-heart tooltip1`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  wishCountFunc(categoryItem);
                                }}
                                style={{ fontSize: '1rem', color: wishState[categoryItem.id] ? '#e63946' : '#777', cursor: 'pointer' }}
                              >
                                {categoryItem.wishListCount !== 0 && (
                                  <span className="tooltiptext">{categoryItem.wishListCount}</span>
                                )}
                              </CardRating>
                            </div>


                            <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                              <CardImageContainer style={{ width: '100%', height: '100%' }}>
                                <img
                                  src={
                                    categoryItem.images === "@#@"
                                      ? Noimg
                                      : categoryItem.images.split("@#@")[0]
                                  }
                                  alt={categoryItem.title}
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    transition: 'transform 0.3s ease',
                                  }}
                                  className="group-hover:scale-105"
                                />
                              </CardImageContainer>

                              {categoryItem.stockStatus === "Sale" && (
                                <>
                                  <div style={{ position: "absolute", top: 10, left: 10, zIndex: 5 }}>
                                    <div
                                      className={categoryItem.discountValue > 0 ? "badge-slide badge-available" : ""}
                                      style={{
                                        backgroundColor: "#facc15",
                                        padding: "4px 8px",
                                        fontSize: "11px",
                                        borderRadius: "10px",
                                        fontWeight: "600",
                                        userSelect: "none",
                                        color: "#333",
                                        position: "absolute",
                                        width: "max-content",
                                        textAlign: "center",
                                        animation: categoryItem.discountValue > 0 ? "badgeShow 6s infinite" : "none"
                                      }}
                                    >
                                      Available
                                    </div>

                                    {categoryItem.discountValue > 0 && (
                                      <div
                                        className="badge-slide badge-discount"
                                        style={{
                                          backgroundColor: "#3bfa15ff",
                                          padding: "4px 8px",
                                          fontSize: "11px",
                                          borderRadius: "10px",
                                          fontWeight: "600",
                                          userSelect: "none",
                                          color: "#000000", 
                                          position: "absolute",
                                          width: "max-content",
                                          textAlign: "center",
                                        }}
                                      >
                                        {categoryItem.discountType === "rs"
                                          ? `₹${categoryItem.discountValue} off`
                                          : `${categoryItem.discountValue}% off`}
                                      </div>
                                    )}
                                  </div>


                                </>
                              )}
                            </div>

                            <CardText style={{ padding: '10px', overflow: 'hidden' }}>
                              <div className="d-flex justify-content-between mb-1 align-items-start h-100">
                                <div className="col-md-7">
                                  <CardTitle
                                    className="capitalize mb-1"
                                    style={{ fontSize: '14px', fontWeight: '600' }}
                                  >
                                    {categoryItem.metalType}
                                  </CardTitle>

                                  <CardContent
                                    className="capitalize"
                                    style={{
                                      fontSize: '15px',
                                      color: '#facc15',
                                      lineHeight: '1.3',
                                      display: '-webkit-box',
                                      WebkitLineClamp: 2,
                                      WebkitBoxOrient: 'vertical',
                                      overflow: 'hidden',
                                      fontWeight: 'bold'
                                    }}
                                    title={categoryItem.title}
                                  >
                                    {categoryItem.title}
                                  </CardContent>
                                </div>

                                <div className="col-md-5 text-end">
                                  {categoryItem.stockStatus.toLowerCase() !== 'sold' && (
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>

                                      <b
                                        style={{
                                          fontSize: '14px',
                                          fontWeight: '700',
                                          color: '#000',
                                          display: 'flex',
                                          flexDirection: 'column',
                                          alignItems: 'flex-end',
                                          gap: '2px'
                                        }}
                                      >
                                        <span style={{ fontSize: '15px' }}>
                                          ₹{categoryItem.discountAmt > 0 && categoryItem.discountAmt !== categoryItem.total
                                            ? categoryItem.discountAmt.toFixed(2)
                                            : categoryItem.total.toFixed(2)}
                                        </span>

                                        {categoryItem.discountAmt > 0 && categoryItem.discountAmt !== categoryItem.total && (
                                          <span
                                            style={{
                                              fontSize: '14px',
                                              color: '#999',
                                              textDecoration: 'line-through',
                                              fontWeight: '900'
                                            }}
                                          >
                                            ₹{categoryItem.total.toFixed(2)}
                                          </span>
                                        )}
                                      </b>

                                      {/* GOLD PURITY */}
                                      {categoryItem.goldPurity !== "-" && (
                                        <small
                                          style={{
                                            fontSize: '11px',
                                            color: '#666',
                                            marginTop: '2px'
                                          }}
                                        >
                                          {categoryItem.goldPurity}
                                        </small>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </CardText>

                          </Card>
                        </CardContainer>
                      </TabContent>

                    )
                  })}
                <DecoratorBlob1 />
                <DecoratorBlob2 />
              </div>
            ) : (
              <div className="d-flex justify-content-center align-items-center py-5">
                <img
                  src={logo}
                  alt="No products available"
                  className="img-fluid"
                  style={{
                    maxWidth: "150px",
                    padding: "40px",
                    opacity: 0.8,
                    objectFit: "contain",
                  }}
                />
              </div>

            )}

            {loading && <SkeletonLoader />}
          </section>
        </div>
      </div>

    </Container>
  );
};